import styled from "styled-components";

import { colorsPalettes, setFontVariant, $robotoFontFamily } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const ModalContent = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-content: flex-start;
    justify-content: space-between;
    flex: 1 0 100%;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 550px;
    max-height: 400px;
`;

export const Header = styled(Flex)`
    justify-content: flex-start;
    margin: 20px 24px;
`;

export const Title = styled.h5`
    margin: 0;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    font-family: ${$robotoFontFamily};
`;

export const Content = styled.div<{ scrollable?: boolean; secondScreen?: boolean }>`
    margin: 0 24px;
    display: flex;
    flex: 1 0 100%;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    max-width: 500px;
    ${({ scrollable }) =>
        scrollable &&
        `
        min-height: 275px;
        max-height: 300px;
        overflow-y: scroll;
    `}
    ${({ secondScreen }) =>
        secondScreen &&
        `
        min-height: 266px;
        height: 266px;
        max-height: 266px;        
        max-width: 525px;
        margin: 0 0 0 24px;        
    `}
`;

export const Footer = styled(Flex)<{ flex?: boolean }>`
    border-top: 1px solid #dedede;
    justify-content: flex-end;
    width: 550px;
    padding: 16px 24px 16px 24px;
    ${({ flex }) =>
        flex &&
        `
            display: flex;
            width: 100%;
        `}
`;

export const GeneralButton = styled(Button)`
    ${setFontVariant("button", colorsPalettes.carbon[0])};
    justify-content: center;
`;
